import React from 'react';
import AuthContainer from '../index';
import Form from '../../../components/molecules/forms';
import Button from '../../../components/molecules/buttons';
import useForgotPassword from './hooks';

function ForgotPassword() : React.ReactElement {
  const { navigateToLogin, formik, isLoading } = useForgotPassword();
  return (
    <AuthContainer
      title="Forgot Password"
      description="Your one-stop solution for vending management!"
      onBack={navigateToLogin}
    >
      <form
        aria-label="form"
        onSubmit={formik.handleSubmit}
        className="form-container"
      >
        <Form.Default
          id="username"
          label="Email Address"
          placeholder="Enter email address"
          value={formik.values.username}
          onChange={formik.handleChange}
          className="mb-4"
          isInvalid={formik.touched.username && !!formik.errors.username}
          errorMsg={formik.errors.username}
          onBlur={formik.handleBlur}
          validation
        />
        <div className="mt-5">
          <Button.Default
            id="submitForgotPassword"
            type="submit"
            label="Submit"
            className="fw-bold"
            loading={isLoading}
          />
        </div>
      </form>
    </AuthContainer>
  );
}

export default ForgotPassword;
